import { Trustpilot } from '../trustpilot';

const TrustpilotSection = () => {
  return (
    <div className="trustpilot-section space-y-8 py-8 md:py-12 lg:py-20 bg-transparent">
      <Trustpilot />
    </div>
  );
};
export { TrustpilotSection };
